import React from "react";
import styles from "./style.module.css";

interface Props {
  style?: React.CSSProperties;
  onChange: (date: string, index: number) => void;
  index: number;
  value: string;
}

export default function DateField({
  style,
  index,
  onChange,
  value,
  ...res
}: Props) {
  return (
    <div>
      <input
        type="date"
        style={{ ...style }}
        className={styles.dateField}
        onChange={(e) => onChange(e.target.value, index)}
        value={value}
        {...res}
      />
    </div>
  );
}
